import { lazy } from 'react';

export const CommunityDetails = lazy(() => import('@complex/user/community/CommunityDetails').then((module) => ({
  default: module.CommunityDetails,
})));

export const LeaderboardsPage = lazy(() => import('@complex/LeaderboardsPage').then((module) => ({
  default: module.LeaderboardsPage,
})));

export const AchievementsPage = lazy(() => import('@complex/AchievementsPage').then((module) => ({
  default: module.AchievementsPage,
})));

export const InProgressQuestsPage = lazy(() => import('@complex/InProgressQuestsPage').then((module) => ({
  default: module.InProgressQuestsPage,
})));

export const ProfileSettingsPage = lazy(() => import('@complex/ProfileSettingsPage').then((module) => ({
  default: module.ProfileSettingsPage,
})));

export const ReferralsPage = lazy(() => import('@complex/ReferralsPage').then((module) => ({
  default: module.ReferralsPage,
})));

export const RewardsHubPage = lazy(() => import('@complex/RewardsHubPage').then((module) => ({
  default: module.RewardsHubPage,
})));

export const BadgesInfoPage = lazy(() => import('@complex/BadgesInfoPage').then((module) => ({
  default: module.BadgesInfoPage,
})));

export const AmbassadorHubPage = lazy(() => import('@complex/AmbassadorHubPage').then((module) => ({
  default: module.AmbassadorHubPage,
})));

export const CommunitiesPage = lazy(() => import('@complex/CommunitiesPage').then((module) => ({
  default: module.CommunitiesPage,
})));

export const CampaignDetailPage = lazy(() => import('@complex/user/community/CampaignDetailPage').then((module) => ({
  default: module.CampaignDetailPage,
})));

export const CommunityOnboardingPage = lazy(() => import('@complex/user/community/CommunityOnboardingPage').then((module) => ({
  default: module.CommunityOnboardingPage,
})));

export const CommunityUserDashboard = lazy(() => import('@complex/user/community/CommunityUserDashboard').then((module) => ({
  default: module.CommunityUserDashboard,
})));

export const CommunityAdminDashboard = lazy(() => import('@complex/community/owner/CommunityAdminDashboard').then((module) => ({
  default: module.CommunityAdminDashboard,
})));

export const PrivacyPolicyPage = lazy(() => import('@complex/PrivacyPolicyPage').then((module) => ({
  default: module.PrivacyPolicyPage,
})));

export const TermsOfServicePage = lazy(() => import('@complex/TermsOfServicePage').then((module) => ({
  default: module.TermsOfServicePage,
})));

export const LoginDialog = lazy(() => import('@complex/LoginDialog').then((module) => ({
  default: module.LoginDialog,
})));

export const SignupDialog = lazy(() => import('@complex/SignupDialog').then((module) => ({
  default: module.SignupDialog,
})));
